import moment from "moment";
import React from "react";
import styled from "styled-components";

export default function LotoDescription({ openPopupWin, codeDetail }) {
  const timerHouse = moment(codeDetail?.codeWinTime).format("HH:mm");
  const timerDay = moment(codeDetail?.codeWinTime).format("DD/MM/YYYY");

  const timeCodeWinFormat = moment(codeDetail?.codeWinTime, "YYYY-MM-DD HH:mm:ss");
  const timeCodeWin = timeCodeWinFormat.add(120, "seconds");
  const timeCurrent = moment();

  const codeWinTime = codeDetail?.codeWinTime;
  const endReceiveTime = codeDetail?.endReceiveTime;
  const handleCheckTimer = (timeAdd = 12) => {
    if(!codeWinTime){
      return;
    }

    const codeWinDate = moment(codeWinTime, "YYYY-MM-DD HH:mm:ss").startOf("day"); // Chỉ lấy phần ngày
    const noonTime = codeWinDate.add(timeAdd, "hours"); // Thêm timeAdd giờ để xác định 12h trưa
    
    const endReceiveTimeCheck = moment(endReceiveTime);
    const currentTime = moment();

    if (endReceiveTimeCheck.isAfter(currentTime)) {
      // console.log("Hiện tại nhỏ hơn timeAdd trưa của ngày codeWinTime.");
      return true
    }

    return false;
  }

  return (
    <Div>
      {timeCodeWin < timeCurrent ? ( // Quay xong
        <div>ဂုဏ်ယူပါတယ်! 🎉 {codeDetail?.isdnWin} သည် ကုဒ် {codeDetail?.codeWin} ဖြင့် အံ့သြဖွယ်ကောင်းသော IPHONE16 ၏ နှစ်သစ်ကူး အထူးဆု ကို ရရှိသွားပါပြီ!!!</div>
      ): handleCheckTimer() ?   ( // trước  11:59:59 ngày 06/01/2025
        <div>Live Drawing ကို <span>{timerDay} တွင် {timerHouse}</span> တွင် ကျင်းပမည်ဖြစ်ပါသည်။ အထူးဆု IPHONE16 ကို အခုပဲ ရယူဖို့ ကုဒ်တွေအများကြီးရယူလိုက်ပါ</div>
      ): ( // sau 12h -> 16h 1/6
        <div>ယနေ့၊ 06.01.2025 တွင် ကျင်းပမည့် Live Drawing မှာ iPhone16 ကံထူးရှင်ကို စောင့်မျှော်နေပါတယ် </div>
      )}
    </Div>
  );
}

const Div = styled.div`
    position: absolute;
    z-index: 6;
    bottom: 145px;
    left: 75px;
    width: 326px;
    color: white;
    font-size: 16px;
    text-align: center;
    height: 80px;
    display: flex;
    align-items: center;
  div {
    font-weight: 300;
  }

  span {
    font-weight: 700;
  }

  @media screen and (max-width: 1400px) {
    bottom: 110px;
    left: 45px;
    width: 287px;

    
  }

  @media (max-width: 576px) {
    font-size: 13px;
    left: 42px;
    width: 252px;
    bottom: 72px;
    left: 47%;
    transform: translateX(-50%);
  }
`;
